function toIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** First and last calendar day of the current month, as 'YYYY-MM-DD' strings. */
export function getCurrentMonthRange(): { dateFrom: string; dateTo: string } {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return { dateFrom: toIsoDate(firstDay), dateTo: toIsoDate(lastDay) };
}

/**
 * Monday through Sunday of the current calendar week, as 'YYYY-MM-DD' strings. Default del filtro
 * de fecha compartido de Reportería (spec funcional Reconocimiento).
 *
 * `Date.getDay()` devuelve 0=domingo…6=sábado; se rota a 0=lunes…6=domingo con `(getDay() + 6) % 7`,
 * el mismo criterio de semana calendario ya vigente en la plataforma (ver StreakWidget, PerfilView,
 * StreakTracker y `SurveyItem.activeDays`), para no inventar un segundo criterio de "semana".
 */
export function getCurrentWeekRange(): { dateFrom: string; dateTo: string } {
  const today = new Date();
  const mondayOffset = (today.getDay() + 6) % 7;
  const monday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - mondayOffset);
  const sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
  return { dateFrom: toIsoDate(monday), dateTo: toIsoDate(sunday) };
}
